import {AnyProduct, ProductData} from "./types";

type ProductWithPrice = Pick<AnyProduct, "minimumPrice" | "card_price">;

export const getMinimalProductPrice = (product: ProductWithPrice) => {
    if (product.minimumPrice && product.minimumPrice > 0) return product.minimumPrice;

    return product.card_price;
};

export const getPriceFromProductData = (productData: ProductData) => {
    const original = productData?.price;
    const current = productData?.card_price;
    const discount = productData?.card_discount;
    const hasDiscount = discount !== 0 && productData?.kol !== 0;

    return {
        current,
        original,
        discount,
        hasDiscount,
    };
}
